import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from '../../../../components';
import FilterComponent from '../../../../containers/SearchPage/FilterComponent';

import css from './FiltersModal.module.css';

const FiltersModal = props => {
  const {
    isOpen,
    onClose,
    onManageDisableScrolling,
    resetAll,
    urlQueryParams,
    listingCategories,
    marketplaceCurrency,
    initialValues,
    getHandleChangedValueFn,
    intl,
    availableFilters,
    resultsCount,
  } = props;

  return (
    <Modal
      id="SearchPage.FiltersModal"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="FiltersModal.title" />
      </p>
      {availableFilters.map(filterConfig => {
        const key = `SearchFilters.${filterConfig.scope || 'built-in'}.${filterConfig.key}`;
        return (
          <FilterComponent
            key={key}
            idPrefix="SearchFilters"
            config={filterConfig}
            listingCategories={listingCategories}
            marketplaceCurrency={marketplaceCurrency}
            urlQueryParams={urlQueryParams}
            initialValues={initialValues}
            getHandleChangedValueFn={getHandleChangedValueFn}
            intl={intl}
            liveEdit
            showAsPopup={false}
          />
        );
      })}
      <div className={css.showListingsContainer}>
        <button className={css.clearAllButton} onClick={resetAll}>
          <FormattedMessage id="FilterPlain.clear" />
        </button>
        <button className={css.showListingsButton} onClick={onClose}>
          <FormattedMessage
            id="SearchFiltersMobile.showListings"
            values={{ count: resultsCount }}
          />
        </button>
      </div>
    </Modal>
  );
};

export default FiltersModal;
